import { graphql, StaticQuery } from 'gatsby'
import React, { useState, useEffect } from 'react'
import MenuItem from '../Menu/MenuItem'
import { GatsbyImage } from "gatsby-plugin-image"

import './Footer.scss'
import GenerarAlt from "../../utils/GenerarAlt"

const FOOTER_QUERY = graphql`
{
  pionero {
    page(id: "675", idType: DATABASE_ID) {
      general {
        tituloOficinaCentral
        tituloInformacionDe
        telefonoOficinaCentral
        direccionOficinaCentral
        parrafoLasImagenesEn
        imagenFooter {
          ...imagenFooter
        }
        imagenLibro{
          ...imagen
        }
        tituloCookies
        descripcionCookies        
      }
    }
    menuItems(where: {parentId: "", location: HCMS_MENU_FOOTER}) {
      ...menuItems
    }
    generalSettings {
      url
    }
  }
}

fragment menuItems on Pionero_RootQueryToMenuItemConnection {
  nodes {
    id
    label
    url
    title
    target
    cssClasses
    childItems(before: "") {
      edges {
        node {
          id
          label
          url
          title
          target
        }
      }
    }
  }
}

fragment imagenFooter on Pionero_MediaItem{
  altText
  title
  srcSet
  sourceUrl
  sourceUrlSharp {
    childImageSharp {
      gatsbyImageData(
        formats: [AUTO, WEBP]
        placeholder: NONE
      )
    }
  }
}
`

const DISCLAIMER_VIS = `(*) Todas las imágenes, renders, planos, medidas, áreas y demás piezas gráficas son referenciales y tienen fines ilustrativos, correspondiendo a una etapa preliminar del proyecto. El proyecto se desarrolla bajo el régimen VIS, conforme a la normativa vigente aplicable. Las plantas, distribuciones y demás características podrán variar por ajustes técnicos, estructurales o normativos, incluida la normativa VIS y disposiciones de las autoridades competentes, pudiendo el proyecto sufrir modificaciones durante su desarrollo. El mobiliario, acabados y elementos decorativos son referenciales y no forman parte de la oferta comercial. Los acabados y materiales podrán ser sustituidos por razones técnicas, según disponibilidad y/o elección de los elementos finales.`

const Footer = () => {
  const [showCookiesBanner, setShowCookiesBanner] = useState(false)
  const [isGuardiaCivil, setIsGuardiaCivil] = useState(false)

  useEffect(() => {
    setIsGuardiaCivil(window.location.pathname.includes('/guardia-civil-sur-314'))
  }, [])

  useEffect(() => {
    // Verificar si el usuario ya aceptó/rechazó las cookies
    const cookiesAccepted = localStorage.getItem('cookiesAccepted')
    const cookiesRejected = localStorage.getItem('cookiesRejected')
    const cookiesDate = localStorage.getItem('cookiesDate')

    if (!cookiesAccepted && !cookiesRejected) {
      setShowCookiesBanner(true)
    } else if (cookiesDate) {
      const savedDate = new Date(cookiesDate)
      const currentDate = new Date()
      const daysDifference = (currentDate - savedDate) / (1000 * 60 * 60 * 24)

      if (cookiesAccepted && daysDifference >= 30) {
        // Han pasado 30 días desde aceptar, mostrar banner nuevamente
        setShowCookiesBanner(true)
        localStorage.removeItem('cookiesAccepted')
        localStorage.removeItem('cookiesDate')
      } else if (cookiesRejected && daysDifference >= 7) {
        // Ha pasado 1 semana desde rechazar, mostrar banner nuevamente
        setShowCookiesBanner(true)
        localStorage.removeItem('cookiesRejected')
        localStorage.removeItem('cookiesDate')
      }
    }
  }, [])

  const handleAcceptCookies = () => {
    localStorage.setItem('cookiesAccepted', 'true')
    localStorage.setItem('cookiesDate', new Date().toISOString())
    localStorage.removeItem('cookiesRejected') // Limpiar estado de rechazo previo
    setShowCookiesBanner(false)
  }

  const handleRejectCookies = () => {
    localStorage.setItem('cookiesRejected', 'true')
    localStorage.setItem('cookiesDate', new Date().toISOString())
    localStorage.removeItem('cookiesAccepted') // Limpiar estado de aceptación previa
    setShowCookiesBanner(false)
  }

  return (
    <StaticQuery
      query={FOOTER_QUERY}
      render={(data) => {
        const menuItems = data.pionero?.menuItems?.nodes
        const wordPressUrl = data.pionero?.generalSettings?.url
        const footer = data.pionero.page?.general

        return (
          <>
            <footer className="footer bg-negro">
              <div className="footer-contenido mwx-1680 mx-auto d-flex">
                <div className="footer-item">
                  {
                    (footer && footer.tituloInformacionDe) &&
                    <h3
                      className="footer-item-titulo weight-400">
                      {footer.tituloInformacionDe}
                    </h3>
                  }

                  {
                    menuItems &&
                    <ul>
                      {
                        menuItems.map((menuItem, i) => (
                          <MenuItem
                            key={i}
                            menuItem={menuItem}
                            wordPressUrl={wordPressUrl}
                          />
                        ))
                      }
                    </ul>
                  }
                </div>
                <div className="footer-item">
                  {
                    (footer && footer.tituloOficinaCentral) &&
                    <h3 className="footer-item-titulo weight-400">{footer.tituloOficinaCentral}</h3>
                  }

                  <div className='footer-direccion-lr'>

                    <div>
                      {
                        (footer && footer.telefonoOficinaCentral) &&
                        <a
                          href={`tel:051${footer.telefonoOficinaCentral}`}
                          className="footer-item-telefono color-blanco weight-400">
                          {footer.telefonoOficinaCentral}
                        </a>
                      }


                      {
                        (footer && footer.direccionOficinaCentral) &&
                        <div
                          className="footer-item-direccion color-blanco weight-400"
                          dangerouslySetInnerHTML={{ __html: footer.direccionOficinaCentral }}

                        />
                      }
                    </div>

                    {
                      // Mostrar imagenLibro debajo de la dirección
                      (footer && footer.imagenLibro) &&
                      <a
                        href="/libro-de-reclamaciones/"
                        className="footer-libro-link"
                      >
                        <GatsbyImage
                          image={footer.imagenLibro.sourceUrlSharp.childImageSharp.gatsbyImageData}
                          alt={GenerarAlt(footer.imagenLibro)}
                          className='footer-imagen-libro'
                        />
                      </a>
                    }
                  </div>
                </div>



                <div className="footer-item">
                  {
                    (footer && footer.imagenFooter) &&
                    <a href="https://adiperu.pe/" target="_blank" rel="noopener noreferrer">
                      <GatsbyImage
                        className="footer-imagen weight-400"
                        image={footer.imagenFooter.sourceUrlSharp.childImageSharp.gatsbyImageData}
                        alt={GenerarAlt(footer.imagenFooter)} />
                    </a>
                  }
                </div>
              </div>
              {isGuardiaCivil ? (
                <div className="footer-info color-blanco weight-400 mwx-1680 mx-auto">
                  {DISCLAIMER_VIS}
                </div>
              ) : (
                (footer && footer.parrafoLasImagenesEn) &&
                <div
                  className="footer-info color-blanco weight-400 mwx-1680 mx-auto"
                  dangerouslySetInnerHTML={{ __html: footer.parrafoLasImagenesEn }}
                />
              )}
            </footer>

            {/* Banner de Cookies */}
            {showCookiesBanner && (
              <div className="cookies-banner">
                <div className="cookies-content">
                  <div className="cookies-text">
                    {footer?.tituloCookies && (
                      <h4 className="cookies-title">{footer.tituloCookies}</h4>
                    )}
                    {footer?.descripcionCookies && (
                      <p className="cookies-description"
                        dangerouslySetInnerHTML={{ __html: footer.descripcionCookies }} />
                    )}
                  </div>
                  <div className="cookies-buttons">
                    <button
                      className="cookies-btn cookies-btn-accept"
                      onClick={handleAcceptCookies}
                    >
                      Aceptar
                    </button>
                    <button
                      className="cookies-btn cookies-btn-reject"
                      onClick={handleRejectCookies}
                    >
                      Rechazar
                    </button>
                  </div>
                </div>
              </div>
            )}
          </>
        )
      }}
    />
  )

}

export default Footer
